import styled from 'styled-components';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@controlrooms/components';

interface ShareConfirmModalProps {
  onSave: () => void;
  onSkip: () => void;
  onCancel: () => void;
}

const MessageText = styled.p`
  padding: 16px;
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.modal.header.subHeaderColor};
`;

const FooterActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ShareConfirmModal = ({ onSave, onSkip, onCancel }: ShareConfirmModalProps) => (
  <Modal open={true} onCancel={onCancel} size="sm">
    <ModalHeader title="Save before sharing?" />
    <ModalBody>
      <MessageText>Do you want to save this tab before sharing?</MessageText>
    </ModalBody>
    <ModalFooter>
      <Button buttonSize="small" buttonType="secondary" onClick={onCancel}>
        Cancel
      </Button>
      <FooterActions>
        <Button buttonSize="small" buttonType="secondary" onClick={onSkip}>
          Share without saving
        </Button>
        <Button buttonSize="small" buttonType="primary" onClick={onSave}>
          Save &amp; Share
        </Button>
      </FooterActions>
    </ModalFooter>
  </Modal>
);
